import { render, staticRenderFns } from "./support-search.vue?vue&type=template&id=c34af8ee&"
import script from "./support-search.vue?vue&type=script&lang=js&"
export * from "./support-search.vue?vue&type=script&lang=js&"
import style0 from "./support-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SupportArticle: require('/opt/build/repo/storefront/components/legacy/support/support-article.vue').default})
